import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  authToken: string | null = '';
  constructor(private httpClient: HttpClient) {
    this.authToken = localStorage.getItem('auth-token');
  }
  private destroySessionUrl =  environment.apiUrl + "user/destroySession";

  destroySession():Observable<Object>{
    return this.httpClient.delete(`${this.destroySessionUrl}`);
   }

  //  deleteUserSession(emailId : string):Observable<Object>{
  //   return this.httpClient.delete(environment.apiUrl + "user/destroySession/" + emailId);
  //  } 
// email to username change
  deleteUserSession(avenue: string): Promise<any> {

    this.authToken = localStorage.getItem('auth-token');

    const self = this;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authToken
    });
    return new Promise((resolve, reject) => {
      self.httpClient.delete(avenue, { headers: headers })
        .toPromise()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
        });
    });
  }

} 
